import { Button, Popup } from '@quickmd-llc/design-system'

type Props = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

/**
 * Confirmation popup for deleting a single visit type from the working set.
 *
 * SCSS → Tailwind: .vs-delete-popup-footer -> flex justify-end gap-sp-1 (8px).
 */
export const DeleteVisitTypePopup = ({ isOpen, onClose, onConfirm }: Props) => (
  <Popup
    isOpen={isOpen}
    header='Delete visit type'
    body={<span>Permanently removes this visit type. This cannot be undone.</span>}
    footer={
      <div className='flex justify-end gap-sp-1'>
        <Button priority='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Button priority='primary' theme='danger' onClick={onConfirm}>
          Delete
        </Button>
      </div>
    }
    onClose={onClose}
  />
)
